import { useEffect, useState } from "react";
import { useCounter } from "../../Helpers/useCounter";
//imagenes
import noimage from "../../assets/icons/productoNoDisponible.svg";
import Retornable from "../../assets/icons/Retornable.svg";
import time from "../../assets/icons/time.svg";
import Oferta from "../../assets/icons/Oferta.svg";
import { Alerta } from "../Cabezote/alerta.component";
import * as constant from "../../global/const";
import { useSelector } from "react-redux";
import { Redemption } from "../Checkout/Redencion/Redemption.page";

const CardProducto = (props) => {
  const carritoRedux = useSelector((state) => state.carrito.carrito);
  const [showMensaje, setShowMensaje] = useState(false);
  const [showModalRedemption, setShowModalRedemption] = useState(false);
  const [mensaje, setMensaje] = useState("");
  const [currentValue, setCurrentValue] = useState(undefined);

  //Ya que viene contenido en un arreglo
  const producto = props.producto;
  /* console.log('producto', props.producto) */
  //const imagenUrl = constant.URL_BASE_IMAGES + "image/" + producto.codigoSku + ".png?" + Math.random();
  const [imagenUrl, setImagenUrl ] = useState(`${constant.URL_BASE_IMAGES}image/${producto.codigoSku}.jpg?${Math.random()}`);

  const {
    counter,
    setCounter,
    handleSubmitAddValidate,
    handleSubmitSubtractValidate,
    handleInputChange,
    handleInputBlur
   } = useCounter(
    carritoRedux["-" + producto.codigoSku]
      ? carritoRedux["-" + producto.codigoSku].cantidad
      : 0,
    setMensaje,
    setShowMensaje,
    setShowModalRedemption
  );
  // const [esFavorito, setEsFavorito] = useState(false);
  const promocion = producto.promocion.filter(
    (promo) => promo.tipoDescuento == 1
  );
  const promocionRedime = producto.promocionRedime.filter(
    (promoR) => promoR.tipoDescuento == 5
  );
  const [showPromo, setShowPromo] = useState(
    promocionRedime.length > 0 || promocion.length > 0
  );
  const [agotado, setAgotado] = useState(
    producto.agotado != null ? (producto.agotado == 1 ? true : false) : false
  );
  let { history } = props;
  const [letreroImagen, setLetreroImagen] = useState(false);

  const redirectToDetailProduct = (producto) => {
    let ruta = history.location.pathname.split("/");
    let res =
      producto.nombre
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .replace(/ /g, "-") +
      "-" +
      producto.codigoSku;
    res = res.replace("/", "-");
    if (ruta[1] === "detalleProducto") {
      history.push("/detalleProducto/" + res);
      window.location.reload();
      window.scrollTo(0, 0);
    }

    history.push("/detalleProducto/" + res);
  };
  //Agregar o eliminar productos, 1 para agregar y 0 para eliminar

  const handleClickAdd = () => {
    /** 
    if(Number.isInteger(counter)){
      handleSubmitAdd();
      handleChangeToCard(producto);
    }else{
      handleSubmitAdd(0.5);
      handleChangeToCard(producto, 0.5);
    }
    */
   handleSubmitAddValidate(producto)
  };

  const handleClickDelete = () => {
    /** 
    if(Number.isInteger(counter) && counter !== 1){
      handleSubmitSubtract();
      subtractFromCart(producto);
    }else{
      handleSubmitSubtract(0.5);
      subtractFromCart(producto, 0.5);
    }
    */
    handleSubmitSubtractValidate(producto)
  };

  useEffect(() => {
    if (carritoRedux["-" + producto.codigoSku]) {
      setCounter(carritoRedux["-" + producto.codigoSku].cantidad);
    } else {
      setCounter(0);
    }
  }, [carritoRedux]);

  return (
    <div className="cardProducto">
      {showMensaje && (
        <Alerta
          history={history}
          mensaje={mensaje}
          show={showMensaje}
          setShow={setShowMensaje}
          setShowModalRedemption={setShowModalRedemption}
          tipo={0}
        />
      )}
      {showModalRedemption && (
        <Redemption
          codigoSku={mensaje.split("-")[1]}
          setShowModalRedemption={setShowModalRedemption}
        />
      )}

      {/** Cuadro con el texto de imagen no disponible
                letreroImagen
                &&
                <div className="cardProducto-SinImagen">
                    <div className="cardProducto-SinImagen-cajaTexto">
                        <p>Imagen no disponible</p>
                    </div>
                </div>
            
                */}
      {agotado && (
        <div
          className="cardProducto-agotado"
          onClick={() => {
            redirectToDetailProduct(producto);
          }}
        >
          <div className="cardProducto-agotado-cajaTexto">
            <p>AGOTADO</p>
          </div>
        </div>
      )}

      {/*  
      <i
        className={(esFavorito ? "fa fa-star imagen-estrella" : "fa fa-star-o imagen-estrella")}
        onClick={() => {
          setEsFavorito(fav => {
          return !fav;
          })
        }}>
      </i> 
      */}
      <div className="cardVineta">
        {producto.vinetas.map((vineta) => {
          return (
            <div
              key={vineta.nombre}
              className="vineta"
              style={{
                backgroundColor: vineta.color + "8c",
                border: vineta.colorTexto + " 1px solid",
                color: vineta.colorTexto,
                zIndex: 1,
              }}
            >
              <div>
                <span
                  style={{
                    backgroundColor: vineta.colorTexto,
                    color: vineta.colorTexto,
                  }}
                >
                  ..
                </span>
              </div>
              <p>{vineta.texto}</p>
            </div>
          );
        })}
      </div>

      <div
        className="imagen"
        style={{
          opacity: agotado ? "0.5" : "1",
        }}
        onClick={() => {
          redirectToDetailProduct(producto);
        }}
      >
        <img
          src={imagenUrl}
          loading="lazy"
          alt="Not Found"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = noimage;
            setLetreroImagen(true);
          }}
          style={{ width: "80%" }}
        />
      </div>
      <div
        className="nombre-producto"
        onClick={() => {
          redirectToDetailProduct(producto);
        }}
      >
        <h2>{producto.nombre}</h2>
      </div>
      <div className="presentacion-producto">
        <p>{producto.presentacionNombre}</p>
        <hr />
      </div>

      <div className="contenedor-item-box">
        <div className="item-box">
          {producto.caracteristicaEstado === 1 ? (
            <>
              <img className="icon-producto" src={time} alt="" loading="lazy"/>{" "}
              <p>{producto.caracteristica}</p>
            </>
          ) : null}
        </div>
        <div className="item-box">
          {producto.retornable !== "" ? (
            <>
              <img className="icon-producto" src={Retornable} alt="" />{" "}
              <p>{producto.retornable}</p>
            </>
          ) : null}
        </div>
        {(promocion.length > 0 || promocionRedime.length > 0) && (
          <div className="item-box">
            <img
              className="icon-producto"
              loading="lazy"
              src={Oferta}
              alt=""
              style={{
                display: showPromo ? "auto" : "none",
              }}
            />
            <p
              id="oferta"
              style={{
                display: showPromo ? "auto" : "none",
              }}
            >
              {promocion.length > 0
                ? promocion[0].textoDescuento
                : promocionRedime.length > 0
                ? promocionRedime[0].textoDescuento
                : ""}
            </p>
          </div>
        )}
        <hr />
      </div>

      <div className="precio-producto">
        {producto.precioSinDescuento > producto.precio && (
          <p className="subrayado">
            Antes{" "}
            {" $" +
              new Intl.NumberFormat("de-DE", {
                numberingSystem: "latn",
                style: "decimal",
                currency: "COP",
              }).format(
                promocion.length > 0
                  ? promocion[0].precioSinDescuento
                  : producto.precioSinDescuento
              )}
          </p>
        )}
        <h2>
          {" $" +
            new Intl.NumberFormat("de-DE", {
              numberingSystem: "latn",
              style: "decimal",
              currency: "COP",
            }).format(
              promocion.length > 0 ? promocion[0].precio : producto.precio
            )}
        </h2>
      </div>

      <div className={"operaciones-producto " + (agotado && "agotado")}>
        <div className={"operaciones-producto-contador"}>
          <i
            className="fa fa-minus-circle"
            aria-hidden="true"
            disabled={false}
            onClick={() => handleClickDelete()}
          ></i>
          {/* <p>{counter}</p> */}

          <input
            className="digitacion"
            onFocus={(e) => e.target.select()}
            onBlur={(e) => handleInputBlur(e.target.value, producto, setCurrentValue)}
            /* value={counter} */
            onChange={(e) => handleInputChange(e.target.value, producto, setCurrentValue )}
            value={currentValue ?? counter}
          />

          <i
            className="fa fa-plus-circle"
            aria-hidden="true"
            onClick={() => handleClickAdd()}
          ></i>
        </div>

        {/** Boton Agregar**/}
        {/* <button
                    type="button"
                    onClick={
                        () => {
                            setShowMensaje(false);
                            handleAddToCart(producto);
                            // if (_carritoPromos["-" + producto.codigoSku]) {
                            //     setshowMensaje(true);
                            //     setMensaje(_carritoPromos["-" + producto.codigoSku].textoDescuentoDetalle + "-" + producto.codigoSku);
                            // }

                            // setMensaje("is simply dummy text of the printing and typesetting industry - Lorem Ipsum has been the industry's standard dummy");
                            // executeScroll();
                            // setTimeout(() => {
                            //     setMensaje("");
                            // }, 5000);
                        }
                    }
                >Agregar</button> */}
      </div>
    </div>
  );
};

export default CardProducto;
